import { Ability } from '@casl/ability';

export default new Ability([
  {
    action: 'read',
    subject: 'OwnHoraire'
  },
  {
    action: 'delete',
    subject: 'Post',
    conditions: { published: true },
    inverted: false
  }
]);
